// Car Features Definition with DE/EN translations
// Icons are Lucide icon names (used with dynamic import)
export const CAR_FEATURES = {
  comfort_climate: {
    icon: "Snowflake",
    name_de: "Komfort & Klima",
    name_en: "Comfort & Climate",
    features: [
      { key: "air_conditioning", de: "Klimaanlage", en: "Air Conditioning" },
      { key: "climate_control", de: "Klimaautomatik", en: "Climate Control" },
      { key: "heated_seats", de: "Sitzheizung", en: "Heated Seats" },
      { key: "ventilated_seats", de: "Sitzbelüftung", en: "Ventilated Seats" },
      { key: "heated_steering", de: "Lenkradheizung", en: "Heated Steering Wheel" },
      { key: "auxiliary_heating", de: "Standheizung", en: "Auxiliary Heating" },
      { key: "electric_seats", de: "Elektrische Sitze", en: "Electric Seats" },
      { key: "memory_seats", de: "Memory-Sitze", en: "Memory Seats" },
      { key: "armrest", de: "Mittelarmlehne", en: "Center Armrest" },
      { key: "ambient_lighting", de: "Ambientebeleuchtung", en: "Ambient Lighting" },
    ]
  },
  infotainment: {
    icon: "Smartphone",
    name_de: "Infotainment & Navigation",
    name_en: "Infotainment & Navigation",
    features: [
      { key: "navigation", de: "Navigationssystem", en: "Navigation System" },
      { key: "touchscreen", de: "Touchscreen", en: "Touchscreen" },
      { key: "apple_carplay", de: "Apple CarPlay", en: "Apple CarPlay" },
      { key: "android_auto", de: "Android Auto", en: "Android Auto" },
      { key: "bluetooth", de: "Bluetooth", en: "Bluetooth" },
      { key: "usb_port", de: "USB-Anschluss", en: "USB Port" },
      { key: "wifi_hotspot", de: "WLAN / Hotspot", en: "WiFi / Hotspot" },
      { key: "voice_control", de: "Sprachsteuerung", en: "Voice Control" },
      { key: "premium_sound", de: "Soundsystem (Bose, Harman Kardon)", en: "Premium Sound System" },
    ]
  },
  safety: {
    icon: "Shield",
    name_de: "Sicherheit & Assistenzsysteme",
    name_en: "Safety & Assistance Systems",
    features: [
      { key: "abs", de: "ABS", en: "ABS" },
      { key: "esp", de: "ESP", en: "ESP" },
      { key: "traction_control", de: "Traktionskontrolle", en: "Traction Control" },
      { key: "airbags", de: "Airbags (Front / Seite / Kopf)", en: "Airbags (Front / Side / Head)" },
      { key: "emergency_brake", de: "Notbremsassistent", en: "Emergency Brake Assist" },
      { key: "lane_keep", de: "Spurhalteassistent", en: "Lane Keep Assist" },
      { key: "blind_spot", de: "Spurwechselassistent (Totwinkel)", en: "Blind Spot Monitor" },
      { key: "adaptive_cruise", de: "Abstandsregeltempomat", en: "Adaptive Cruise Control" },
      { key: "fatigue_detection", de: "Müdigkeitserkennung", en: "Fatigue Detection" },
      { key: "traffic_sign", de: "Verkehrszeichenerkennung", en: "Traffic Sign Recognition" },
      { key: "night_vision", de: "Nachtsichtassistent", en: "Night Vision Assistant" },
    ]
  },
  parking: {
    icon: "ParkingCircle",
    name_de: "Einparken & Rangieren",
    name_en: "Parking & Maneuvering",
    features: [
      { key: "parking_rear", de: "Einparkhilfe hinten", en: "Rear Parking Sensors" },
      { key: "parking_front", de: "Einparkhilfe vorne", en: "Front Parking Sensors" },
      { key: "rear_camera", de: "Rückfahrkamera", en: "Rear Camera" },
      { key: "camera_360", de: "360°-Kamera", en: "360° Camera" },
      { key: "park_assist", de: "Automatischer Parkassistent", en: "Automatic Park Assist" },
    ]
  },
  lights: {
    icon: "Lightbulb",
    name_de: "Licht & Sicht",
    name_en: "Lights & Vision",
    features: [
      { key: "led_headlights", de: "LED-Scheinwerfer", en: "LED Headlights" },
      { key: "xenon_headlights", de: "Xenon-Scheinwerfer", en: "Xenon Headlights" },
      { key: "matrix_led", de: "Matrix-LED", en: "Matrix LED" },
      { key: "high_beam_assist", de: "Fernlichtassistent", en: "High Beam Assist" },
      { key: "fog_lights", de: "Nebelscheinwerfer", en: "Fog Lights" },
      { key: "rain_sensor", de: "Regensensor", en: "Rain Sensor" },
      { key: "light_sensor", de: "Lichtsensor", en: "Light Sensor" },
      { key: "heated_mirrors", de: "Beheizbare Außenspiegel", en: "Heated Mirrors" },
    ]
  },
  exterior: {
    icon: "DoorOpen",
    name_de: "Fenster, Türen & Dach",
    name_en: "Windows, Doors & Roof",
    features: [
      { key: "power_windows", de: "Elektrische Fensterheber", en: "Power Windows" },
      { key: "central_locking", de: "Zentralverriegelung", en: "Central Locking" },
      { key: "keyless", de: "Keyless Go / Entry", en: "Keyless Go / Entry" },
      { key: "sunroof", de: "Schiebedach", en: "Sunroof" },
      { key: "panorama_roof", de: "Panorama-Dach", en: "Panoramic Roof" },
      { key: "power_tailgate", de: "Elektrische Heckklappe", en: "Power Tailgate" },
    ]
  },
  drivetrain: {
    icon: "Cog",
    name_de: "Fahrwerk & Technik",
    name_en: "Drivetrain & Technology",
    features: [
      { key: "automatic_transmission", de: "Automatikgetriebe", en: "Automatic Transmission" },
      { key: "all_wheel_drive", de: "Allradantrieb", en: "All-Wheel Drive" },
      { key: "sport_suspension", de: "Sportfahrwerk", en: "Sport Suspension" },
      { key: "air_suspension", de: "Luftfederung", en: "Air Suspension" },
      { key: "start_stop", de: "Start-Stopp-System", en: "Start-Stop System" },
      { key: "drive_modes", de: "Fahrmodi (Eco / Sport / Comfort)", en: "Drive Modes (Eco / Sport / Comfort)" },
    ]
  },
  design_other: {
    icon: "Palette",
    name_de: "Design & Sonstiges",
    name_en: "Design & Other",
    features: [
      { key: "alloy_wheels", de: "Alufelgen", en: "Alloy Wheels" },
      { key: "sport_package", de: "Sportpaket", en: "Sport Package" },
      { key: "leather_interior", de: "Leder-Innenausstattung", en: "Leather Interior" },
      { key: "isofix", de: "Isofix", en: "Isofix" },
      { key: "tow_hitch", de: "Anhängerkupplung", en: "Tow Hitch" },
      { key: "roof_rails", de: "Dachreling", en: "Roof Rails" },
      { key: "non_smoker", de: "Nichtraucherfahrzeug", en: "Non-Smoker Vehicle" },
    ]
  }
};

// Get all feature keys as a flat array
export const getAllFeatureKeys = () => {
  const keys = [];
  Object.values(CAR_FEATURES).forEach(category => {
    category.features.forEach(feature => {
      keys.push(feature.key);
    });
  });
  return keys;
};

// Get feature label by key and language
export const getFeatureLabel = (key, language = 'de') => {
  for (const category of Object.values(CAR_FEATURES)) {
    const feature = category.features.find(f => f.key === key);
    if (feature) {
      return feature[language] || feature.de;
    }
  }
  return key;
};

export default CAR_FEATURES;
